import { createStore } from 'vuex'

export default createStore({
    //can only be modified by an action or a mutation
    //actions mutations and states
    strict: true,
    state: {
        token: null,
        user: null,
        isUserLoggedIn: false,
        lut: null,
        searchitems: null
    },
    
    mutations: {
        //method with same name
        settoken (state, token) {
            state.token = token
            if (token) {
                state.isUserLoggedIn = true
            } else {
                state.isUserLoggedIn = false
            }
        },

        setuser (state, token) {
            state.token = token
        }

        // setlut (state, lut) {
        //     state.lut = lut
        // },

        // setsearch (state, items) {
        //     state.searchitems = items
        // }
    },

    actions: {
        //do async logic
        setToken ({commit}, token) {
            commit('settoken', token)
        },

        setUser ({commit}, token) {
            commit('setuser', token)
         }

        // setLut ({commit}, lut) {
        //     commit('setlut', lut)
        // },

        // setSearch ({commit}, items) {
        //     commit('setsearch', items)
        // }
    }

})
